import { type IHttpApi } from '@cian/http-api';

import {
  type TCianApiSiteV1FilterPikNewbuildingsResponse,
  fetchCianApiSiteV1FilterPikNewbuildings,
} from 'shared/repositories/monolith-python/cian-api/site/v1/filter-pik-newbuildings';
import { IFilterPikNewbuildingsResponseSchema82 } from 'shared/repositories/monolith-python/entities/schemas/FilterPikNewbuildingsResponseSchema82';
import { type IFilterPikNewbuildingsRequest } from 'shared/types/residentials';

import { assertNotFoundError } from './assert/assertNotFoundError';

export const getFilteredResidentialComplexes = async ({
  httpApi,
  parameters,
  subdomain,
}: {
  httpApi: IHttpApi;
  parameters: IFilterPikNewbuildingsRequest;
  subdomain: string;
}): Promise<number[]> => {
  const response = await fetchCianApiSiteV1FilterPikNewbuildings<
    TCianApiSiteV1FilterPikNewbuildingsResponse,
    TCianApiSiteV1FilterPikNewbuildingsResponse
  >({
    config: { subdomain },
    httpApi,
    parameters,
  });

  assertNotFoundError(response);

  return (response.response as IFilterPikNewbuildingsResponseSchema82).data.newbuildingIds || [];
};
